/* ============================================================
   TELEPORTATION — Floating gallery theme — behaviour
   ------------------------------------------------------------
   - Home gallery: CSS grid handles centering; JS only assigns
     the slow float animation to each item.
   - Product page: TWO independent roots can exist in the DOM
     ([data-tp-product-root]) — desktop (thumbnails column +
     stacked photos the page scrolls through + sticky info
     panel) and mobile (compact horizontal gallery + thumbnail
     strip + fixed info block). Only one is visible at a time
     (CSS), but both are initialised independently and scoped
     to their own root.
   - Cart drawer: global slide-in panel (blurred backdrop) that
     opens after a successful Add to cart, or when the header
     cart icon is clicked. Lets the user adjust quantity, remove
     a line, or jump straight to the cart page or checkout. Uses
     window.TP_MONEY_FORMAT (set in tp-header.liquid from
     shop.money_format) so amounts show in the shop's real
     currency format, not a hardcoded default.
   - Cart page: AJAX quantity change / remove, live totals.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartDrawer = null;

  /* ---------- Money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var value = '';
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ============================================================
     GALLERY (home)
     ============================================================ */
  function layoutGallery() {
    var g = document.querySelector('[data-tp-gallery]');
    if (!g) return;
    var items = Array.prototype.slice.call(g.querySelectorAll('[data-tp-item]'));
    if (!items.length) return;

    items.forEach(function (it) {
      it.style.position = '';
      it.style.left = '';
      it.style.top = '';
      it.style.width = '';

      var fl = it.querySelector('.tp-float');
      if (fl) {
        fl.style.animation = '';
      }
    });

    g.style.height = '';
  }

  function initSmoothProductLinks() {
    var g = document.querySelector('[data-tp-gallery]');
    if (!g) return;
    g.addEventListener('click', function (e) {
      var link = e.target.closest('[data-tp-item]');
      if (!link) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
      e.preventDefault();
      link.classList.add('is-leaving');
      document.body.classList.add('tp-page-leaving');
      setTimeout(function () {
        window.location.href = link.href;
      }, 520);
    });
  }

  /* ============================================================
     ADDED-TO-CART FX — fly dot + cart bump (le tiroir sert de
     confirmation/recap, donc plus de toast ici)
     ============================================================ */
  function cartAddedFx(fromEl) {
    var pill = document.querySelector('.tp-cart');

    if (fromEl && pill) {
      var a = fromEl.getBoundingClientRect();
      var b = pill.getBoundingClientRect();
      var dot = document.createElement('span');
      dot.className = 'tp-fly';
      dot.style.left = (a.left + a.width / 2) + 'px';
      dot.style.top = (a.top + a.height / 2) + 'px';
      document.body.appendChild(dot);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dot.style.transform =
            'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px,' +
            (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(.22)';
          dot.style.opacity = '0';
        });
      });
      setTimeout(function () { if (dot.parentNode) dot.parentNode.removeChild(dot); }, 850);

      setTimeout(function () {
        pill.classList.remove('is-bumping');
        void pill.offsetWidth;
        pill.classList.add('is-bumping');
      }, 560);
    }
  }

  /* ============================================================
     CART DRAWER — global (une seule instance, toutes les pages)
     ============================================================ */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-tp-cart-drawer]');
    if (!drawer) return null;

    var linesEl = drawer.querySelector('[data-tp-cart-drawer-lines]');
    var emptyEl = drawer.querySelector('[data-tp-cart-drawer-empty]');
    var footEl = drawer.querySelector('[data-tp-cart-drawer-foot]');
    var subtotalEl = drawer.querySelector('[data-tp-cart-drawer-subtotal]');
    var moneyFormat = window.TP_MONEY_FORMAT || '${{amount}}';
    var busy = false;

    function renderLine(item) {
      var variant = item.variant_title
        ? '<div class="tp-cart-drawer-line-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      return (
        '<div class="tp-cart-drawer-line" data-tp-cdline data-key="' + item.key + '">' +
          '<div class="tp-cart-drawer-line-img"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '"></div>' +
          '<div class="tp-cart-drawer-line-info">' +
            '<div class="tp-cart-drawer-line-top">' +
              '<span>' + escapeHtml(item.product_title) + '</span>' +
              '<span>' + formatMoney(item.final_line_price, moneyFormat) + '</span>' +
            '</div>' +
            variant +
            '<div class="tp-cart-drawer-line-bottom">' +
              '<div class="tp-qty">' +
                '<button type="button" data-tp-cdqty="-1" aria-label="Decrease quantity">&minus;</button>' +
                '<span data-tp-cdqty-val>' + item.quantity + '</span>' +
                '<button type="button" data-tp-cdqty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="tp-cart-drawer-remove" data-tp-cdremove>DELETE</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function render(cart) {
      if (linesEl) {
        if (!cart.items.length) {
          linesEl.innerHTML = '';
          if (emptyEl) emptyEl.hidden = false;
          if (footEl) footEl.hidden = true;
        } else {
          linesEl.innerHTML = cart.items.map(renderLine).join('');
          if (emptyEl) emptyEl.hidden = true;
          if (footEl) footEl.hidden = false;
        }
      }
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);
      var cc = document.querySelector('[data-tp-cart-count]');
      if (cc) cc.textContent = cart.item_count;
    }

    function refresh() {
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }

    function open() {
      refresh().then(function () {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 280);
    }

    drawer.querySelectorAll('[data-tp-cart-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    if (linesEl) {
      linesEl.addEventListener('click', function (e) {
        if (busy) return;
        var line = e.target.closest('[data-tp-cdline]');
        if (!line) return;
        var key = line.getAttribute('data-key');

        var qbtn = e.target.closest('[data-tp-cdqty]');
        var rbtn = e.target.closest('[data-tp-cdremove]');
        if (!qbtn && !rbtn) return;

        var qty = 0;
        if (qbtn) {
          var val = line.querySelector('[data-tp-cdqty-val]');
          var cur = val ? parseInt(val.textContent, 10) || 1 : 1;
          qty = cur + (parseInt(qbtn.getAttribute('data-tp-cdqty'), 10) || 0);
          if (qty < 0) qty = 0;
        }

        busy = true;
        fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { render(cart); busy = false; })
          .catch(function () { busy = false; });
      });
    }

    /* Icone panier du header : ouvre le tiroir au lieu d'aller sur /cart */
    document.querySelectorAll('[data-tp-cart-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    return { open: open, close: close, refresh: refresh };
  }

  /* ============================================================
     PRODUCT — one call per root (desktop + mobile)
     ============================================================ */
  function initProduct() {
    var page = document.querySelector('[data-tp-product-page]');
    if (!page) return;
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-tp-product-root]'));
    roots.forEach(initProductRoot);
  }

  function initProductRoot(root) {
    var form = root.querySelector('[data-tp-form]');
    var variantInput = root.querySelector('[data-tp-variant-id]');
    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-tp-options]'));
    var priceEl = root.querySelector('[data-tp-price]');
    var atc = root.querySelector('[data-tp-atc]');
    var atcLabel = root.querySelector('[data-tp-atc-label]');
    var qtyInput = root.querySelector('[data-tp-qty-input]');

    var variants = [];
    var moneyFormat = '${{amount}}';
    try {
      variants = JSON.parse(root.querySelector('[data-tp-variants]').textContent);
    } catch (e) {}
    try {
      moneyFormat = JSON.parse(root.querySelector('[data-tp-money-format]').textContent);
    } catch (e) {}

    var currentPrice = 0;
    (function initCurrentPrice() {
      var id = variantInput ? String(variantInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) { currentPrice = variants[i].price; return; }
      }
      if (variants.length) currentPrice = variants[0].price;
    })();

    function clampQty() {
      if (!qtyInput) return 1;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }

    function updatePrice() {
      if (!priceEl || !currentPrice) return;
      priceEl.textContent = formatMoney(currentPrice * clampQty(), moneyFormat);
    }

    /* ---- Sélection multi-options (ex: Couleur + Taille). Le bouton actif peut
       être un .tp-size (texte) ou un .tp-swatch (mini-photo) selon l'option. ---- */
    var selected = {};
    optionGroups.forEach(function (grp) {
      var idx = grp.getAttribute('data-tp-option-index');
      var activeBtn = grp.querySelector('[data-tp-val].is-active');
      if (activeBtn) selected[idx] = activeBtn.getAttribute('data-tp-val');
    });

    function isColorGroup(grp) {
      var n = (grp.getAttribute('data-tp-option-name') || '').toLowerCase();
      return n === 'color' || n === 'colour' || n === 'couleur';
    }

    function variantForSelection() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var key in selected) {
          var pos = parseInt(key, 10) - 1;
          if (!v.options || String(v.options[pos]) !== String(selected[key])) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function applyVariant() {
      var v = variantForSelection();
      if (v) {
        if (variantInput) variantInput.value = v.id;
        currentPrice = v.price;
        if (atc) {
          atc.disabled = !v.available;
          if (atcLabel) atcLabel.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
        }
      } else {
        if (variantInput) variantInput.value = '';
        if (atc) {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'SOLD OUT';
        }
      }
      updatePrice();
    }

    /* Implémentations branchées plus bas selon le layout présent dans ce root */
    var jumpDesktopToColor = function () {};
    var scrollMobileToColor = function () {};

    function onColorChanged(val, opts) {
      opts = opts || {};
      if (opts.fromPill) {
        jumpDesktopToColor(val);
        scrollMobileToColor(val);
      }
    }

    function selectOption(grp, idx, val) {
      selected[idx] = val;
      grp.querySelectorAll('[data-tp-val]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-tp-val') === String(val));
      });
      var label = root.querySelector('[data-tp-option-label="' + idx + '"]');
      if (label) label.textContent = '[ ' + val + ' ]';
      if (isColorGroup(grp)) onColorChanged(val, { fromPill: true });
      applyVariant();
    }

    function syncColorFromValue(c) {
      /* Met à jour le pill/swatch couleur + le label + applyVariant, sans re-déclencher
         de saut d'image (appelé depuis les vignettes/le scroll, pas depuis un clic pill) */
      var colorGroup = optionGroups.filter(isColorGroup)[0];
      if (!colorGroup || !c) return;
      var idxAttr = colorGroup.getAttribute('data-tp-option-index');
      if (selected[idxAttr] === c) return;
      selected[idxAttr] = c;
      colorGroup.querySelectorAll('[data-tp-val]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-tp-val') === c);
      });
      var label = root.querySelector('[data-tp-option-label="' + idxAttr + '"]');
      if (label) label.textContent = '[ ' + c + ' ]';
      applyVariant();
    }

    optionGroups.forEach(function (grp) {
      grp.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tp-val]');
        if (!b || b.disabled) return;
        var idx = grp.getAttribute('data-tp-option-index');
        selectOption(grp, idx, b.getAttribute('data-tp-val'));
      });
    });

    /* ---- Guide des tailles : petit lien inline qui révèle/masque le panneau juste en dessous ---- */
    root.querySelectorAll('[data-tp-sizing-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var label = btn.closest('.tp-size-label');
        var optionsRow = label ? label.nextElementSibling : null;
        var panel = optionsRow ? optionsRow.nextElementSibling : null;
        if (panel && panel.hasAttribute('data-tp-sizing-panel')) {
          panel.hidden = !panel.hidden;
        }
      });
    });

    root.querySelectorAll('[data-tp-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-tp-qty-btn'), 10) || 0;
        var v = clampQty() + d;
        if (v < 1) v = 1;
        qtyInput.value = v;
        updatePrice();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { clampQty(); updatePrice(); });
      qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        if (!isNaN(v) && v >= 1) updatePrice();
      });
    }

    updatePrice();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc && atc.disabled) return;
        clampQty();
        var data = new FormData(form);
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status && res.status !== 200) {
              if (atcLabel) atcLabel.textContent = 'TRY AGAIN';
              return;
            }
            if (atcLabel) atcLabel.textContent = 'ADDED ✓';
            cartAddedFx(atc);
            if (cartDrawer) cartDrawer.open();
            clearTimeout(form._t);
            form._t = setTimeout(function () {
              if (atcLabel) atcLabel.textContent = 'ADD TO CART';
            }, 2200);
          })
          .catch(function () {
            if (atcLabel) atcLabel.textContent = 'TRY AGAIN';
          });
      });
    }

    /* ============================================================
       Desktop — vignettes + photos empilées (scroll de la page).
       ============================================================ */
    var dMainImgs = Array.prototype.slice.call(root.querySelectorAll('[data-tp-dmain-img]'));
    if (dMainImgs.length) {
      var dThumbsArr = Array.prototype.slice.call(root.querySelectorAll('[data-tp-dthumb]'));

      dThumbsArr.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = parseInt(t.getAttribute('data-tp-dthumb'), 10);
          var img = dMainImgs[idx];
          if (img) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });

      jumpDesktopToColor = function (colorVal) {
        var v = String(colorVal || '').toLowerCase();
        var target = dMainImgs.filter(function (img) {
          return (img.getAttribute('data-tp-color') || '').toLowerCase() === v;
        })[0];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      var activeDIdx = -1;
      function onScrollDesktop() {
        var mid = window.scrollY + window.innerHeight * 0.4;
        var idx = 0;
        dMainImgs.forEach(function (img, i) { if (img.offsetTop <= mid) idx = i; });
        if (idx === activeDIdx) return;
        activeDIdx = idx;
        dThumbsArr.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-tp-dthumb'), 10) === idx);
        });
        syncColorFromValue(dMainImgs[idx] ? dMainImgs[idx].getAttribute('data-tp-color') : '');
      }
      window.addEventListener('scroll', onScrollDesktop, { passive: true });
      onScrollDesktop();
    }

    /* ============================================================
       Mobile — scroll horizontal compact + vignettes.
       ============================================================ */
    var mobileSlides = Array.prototype.slice.call(root.querySelectorAll('[data-tp-mslide]'));
    if (mobileSlides.length) {
      var mgallery = root.querySelector('[data-tp-mgallery]');
      var mThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tp-mthumb]'));

      scrollMobileToColor = function (colorVal) {
        if (!mgallery) return;
        var v = String(colorVal || '').toLowerCase();
        var target = mobileSlides.filter(function (s) {
          return (s.getAttribute('data-tp-color') || '').toLowerCase() === v;
        })[0];
        if (target) mgallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      };

      mThumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = parseInt(t.getAttribute('data-tp-mthumb'), 10);
          var slide = mobileSlides[idx];
          if (slide && mgallery) mgallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      var activeSlideIdx = -1;
      function syncFromScroll() {
        if (!mgallery) return;
        var w = mgallery.clientWidth || 1;
        var idx = Math.round(mgallery.scrollLeft / w);
        idx = Math.max(0, Math.min(mobileSlides.length - 1, idx));
        if (idx === activeSlideIdx) return;
        activeSlideIdx = idx;

        mThumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-tp-mthumb'), 10) === idx);
        });

        var slide = mobileSlides[idx];
        syncColorFromValue(slide ? slide.getAttribute('data-tp-color') : '');
      }

      if (mgallery) {
        var st;
        mgallery.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(syncFromScroll, 80);
        }, { passive: true });
      }
      syncFromScroll();
    }
  }

  /* ============================================================
     CART PAGE — AJAX line updates
     ============================================================ */
  function initCart() {
    var page = document.querySelector('[data-tp-cart-page]');
    if (!page) return;

    var moneyFormat = '${{amount}}';
    try {
      moneyFormat = JSON.parse(page.querySelector('[data-tp-money-format]').textContent);
    } catch (e) {}

    var busy = false;

    function change(line, qty) {
      if (busy) return;
      busy = true;
      page.classList.add('is-updating');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (qty === 0 || cart.item_count === 0) {
            window.location.reload();
            return;
          }
          var row = page.querySelector('[data-tp-line="' + line + '"]');
          var item = cart.items[line - 1];
          if (row && item) {
            var qv = row.querySelector('[data-tp-cqty-val]');
            var lp = row.querySelector('[data-tp-line-price]');
            if (qv) qv.textContent = item.quantity;
            if (lp) lp.textContent = formatMoney(item.final_line_price, moneyFormat);
          }
          var sub = page.querySelector('[data-tp-cart-subtotal]');
          if (sub) sub.textContent = formatMoney(cart.total_price, moneyFormat);
          var cl = page.querySelector('[data-tp-cart-count-label]');
          if (cl) cl.textContent = cart.item_count + (cart.item_count === 1 ? ' ITEM' : ' ITEMS');
          var cc = document.querySelector('[data-tp-cart-count]');
          if (cc) cc.textContent = cart.item_count;
          busy = false;
          page.classList.remove('is-updating');
        })
        .catch(function () {
          busy = false;
          page.classList.remove('is-updating');
        });
    }

    page.addEventListener('click', function (e) {
      var qbtn = e.target.closest('[data-tp-cqty]');
      if (qbtn) {
        var row = qbtn.closest('[data-tp-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-tp-line'), 10);
        var cur = parseInt(row.querySelector('[data-tp-cqty-val]').textContent, 10) || 1;
        var next = cur + (parseInt(qbtn.getAttribute('data-tp-cqty'), 10) || 0);
        if (next < 0) next = 0;
        change(line, next);
        return;
      }
      var rbtn = e.target.closest('[data-tp-remove]');
      if (rbtn) {
        var rrow = rbtn.closest('[data-tp-line]');
        if (!rrow) return;
        change(parseInt(rrow.getAttribute('data-tp-line'), 10), 0);
      }
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    layoutGallery();
    initSmoothProductLinks();
    cartDrawer = initCartDrawer();
    initProduct();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(layoutGallery, 150);
  }, { passive: true });

  window.addEventListener('load', layoutGallery);

  /* Retour arrière (bfcache) — efface l'état leaving pour eviter page blanche */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.body.classList.remove('tp-page-leaving');
      document.querySelectorAll('.is-leaving').forEach(function (el) {
        el.classList.remove('is-leaving');
      });
    }
  });
})();
